<template>
  <div>
    已穿戴装备
  </div>
  <div class="equip-tab">
    <!-- 左侧 防具 -->
    <div>
      <div class="equip-item" v-for="o of leftEquip" :key="o">
        <ewg-tooltip v-if="wearableEquips[o]">
          <img
            :src="$imgCatelog.equip[wearableEquips[o].icon]"
            :alt="wearableEquips[o].name"
          />
          <div
            class="equip-icon"
            :class="'grade' + wearableEquips[o].grade"
            @click.right="handleCast(wearableEquips[o])"
          ></div>
          <template v-slot:content>
            <equip-tooltip :equip="wearableEquips[o]"></equip-tooltip>
          </template>
        </ewg-tooltip>
        <div v-else class="empty">{{ equipTypesNames[o] }}</div>
      </div>
    </div>
    <!-- 右侧 武器和首饰 -->
    <div>
      <div class="equip-item" v-for="o of rightEquip" :key="o">
        <ewg-tooltip v-if="wearableEquips[o]">
          <img
            :src="$imgCatelog.equip[wearableEquips[o].icon]"
            :alt="wearableEquips[o].name"
          />
          <div
            class="equip-icon"
            :class="'grade' + wearableEquips[o].grade"
            @click.right="handleCast(wearableEquips[o])"
          ></div>
          <template v-slot:content>
            <equip-tooltip :equip="wearableEquips[o]"></equip-tooltip>
          </template>
        </ewg-tooltip>
        <div v-else class="empty">{{ equipTypesNames[o] }}</div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { useStore } from "@/store";
import { computed, defineComponent, ref } from "vue";
import { PlayerActionTypes } from "@/store/player/action-types";
import { Equipment } from "@/const/equips/equipmentType";
import { equipTypes, equipTypesNames } from "@/const/equips/equipConst";

const store = useStore();
export default defineComponent({
  name: "EquipPack",
  setup() {
    const wearableEquips = computed(() => {
      return store.state.userWearableEquipments;
    });
    const handleCast = (row: Equipment) => {
      store.dispatch(PlayerActionTypes.PLAYER_CAST_EQUIP, row);
    };
    // 左侧装备 防具
    const leftEquip = ref([equipTypes.lorica]);
    // 右侧装备 武器和首饰
    const rightEquip = ref([equipTypes.weapon, equipTypes.necklace]);
    return {
      wearableEquips,
      handleCast,
      leftEquip,
      rightEquip,
      equipTypesNames
    };
  }
});
</script>
<style lang="scss" scoped>
.equip-tab {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.equip-item {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 20px;
  &:last-of-type {
    margin-bottom: 0;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .empty {
    width: 100%;
    height: 100%;
    background: $--color-white-quarter;
    border: 1px solid rgba($color: #ffffaa, $alpha: 0.5);
    box-sizing: border-box;
    border-radius: 4px;
    font-size: 16px;
    line-height: 2.3em;
    text-align: center;
  }
}
</style>
